var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"button",attrs:{"type":"button","title":_vm.$t('LoginButtonTitleAttributeHeaderGetStarted'),"aria-label":_vm.$t('LoginButtonAriaLabelHeaderGetStarted')},on:{"click":_vm.buttonClick}},[_c('span',{class:{
			'wficon-user-circle-outlined': !_vm.hoverOnUserIcon,
			'wficon-user-circle': _vm.hoverOnUserIcon,
		},on:{"mouseenter":function($event){_vm.hoverOnUserIcon = true},"mouseleave":function($event){_vm.hoverOnUserIcon = false}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }